import { Component, EventEmitter, HostListener, Output, TemplateRef, ViewChild } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { KeyTitleModel } from '../../../models/key-value-model';
import { ImagePreview } from '../../../models/image-preview-model';
import heic2any from 'heic2any';
import { LoaderService } from '../../../services/loader.service';

@Component({
  selector: 'app-business-upload',
  templateUrl: './business-upload.component.html',
  styleUrls: ['./business-upload.component.scss']
})
export class BusinessUploadComponent {
  @ViewChild('businessUploadModal') businessUploadTemplate!: TemplateRef<BusinessUploadComponent>;
  selectedFile: File | null = null;
  fileName: string = '';
  images: ImagePreview[] = [];
  csvDownloadUrl: string = 'api/bliss/downloadBusinessTemplate';
  uploadUrl: string = 'api/bliss/uploadBusinesses';
  faileRecordUrl: string = 'api/bliss/downloadRecentBusinessImportErrorFile';
  @Output() onClose = new EventEmitter<any>();
  modalHeight: number;
  uploadDataResponse: any;
  isSuccess: boolean = true;
  imageErrorContentHeight: number;
  headers: string[] = [
    'name',
    'type',
    'cuisine',
    'typeOfMeal',
    'priceRange',
    'address',
    'latitude',
    'longitude',
    'description',
    'businessHours',
    'phoneNumber',
    'webSite',
    'instagram',
    'twitter',
    'businessMessage',
    'amenities',
    'city',
    'country',
    'error'
  ];

  constructor(
    private userService: UserService, private loaderService: LoaderService, private toastr: ToastrService) { }

  ngOnInit() {
    this.adjustModalHeight();
  }

  downloadCSVExample = () => {
    this.userService.downloadCSV(this.csvDownloadUrl)
      .subscribe({
        next: (blob: Blob) => {
          const fileURL = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = fileURL;
          anchor.download = 'PreRegisterBusinessTemplate.csv';
          anchor.click();
          window.URL.revokeObjectURL(fileURL);
          anchor.remove();
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustModalHeight();

  }

  adjustModalHeight() {
    this.modalHeight = window.innerHeight * 0.65;
    this.imageErrorContentHeight = this.modalHeight * 0.32;
    if (this.uploadDataResponse != null) {
      if (this.uploadDataResponse.csvUploadProgress != 2 && this.uploadDataResponse.imageUploadProgress == 2) {
        this.imageErrorContentHeight = this.modalHeight * 0.6;
      }
    }
  }

  onFileSelected = (event: any) => {
    const file = event.target.files[0];
    if (file && (file.type === 'text/csv' || file.name.toLowerCase().endsWith('.csv'))) {
      this.selectedFile = file;
      this.fileName = this.selectedFile.name;
    } else {
      this.toastr.error('Invalid file format. Please upload a CSV file.');
      this.selectedFile = null;
    }
  }

  async onImagesSelected(event: any) {
    const files = event.target.files;

    if (!files.length) {
      return;
    }

    for (let file of files) {
      const fileName = file.name.toLocaleLowerCase();
      const extension = fileName.split('.').pop();

      const isHeicOrHeif = file.type === 'image/heic' || file.type === 'image/heif' || (!file.type && (extension === 'heic' || extension === 'heif'));
      if (isHeicOrHeif) {
        try {
          const convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
          file = new File(
            [convertedBlob as Blob],
            file.name.replace(/\.(heic|heif)$/i, '.jpg'), {
            type: 'image/jpeg'
          });
        }
        catch (error) {
          this.toastr.error('Failed to convert HEIC/HEIF image.');
          return;
        }
      }

      if (file.type.startsWith('image/')) {
        if (file.type == 'image/jpg' || file.type == 'image/png' || file.type == 'image/webp' || file.type == 'image/jpeg') {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.images.push({ file, preview: e.target.result });
          }
          reader.readAsDataURL(file);
          this.images.push(file);
          this.images = this.images.filter(p => p.preview);
        }
        else {
          this.toastr.error('Invalid image format. Please upload JPG, PNG or WebP files.');
        }
      } else {
        this.toastr.error('One or more selected files are not valid images');
      }
    }
  }

  removeImage = (index: number, event: Event) => {
    event.preventDefault();
    this.images.splice(index, 1);
  }


  failedCSVList = () => {
    this.userService.downloadCSV(this.faileRecordUrl)
      .subscribe({
        next: (blob: Blob) => {
          const fileURL = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = fileURL;
          anchor.download = 'failedRecords.csv';
          anchor.click();
          window.URL.revokeObjectURL(fileURL);
          anchor.remove();
        }
      });
  }

  uploadData = () => {
    if (!this.selectedFile && this.images.length <= 0) {
      this.toastr.error('No CSV file or images selected!');
      return;
    }

    const formData = new FormData();
    if (this.selectedFile) {
      formData.append('files', this.selectedFile, this.selectedFile.name);
    }

    if (this.images.length > 0) {
      this.images.forEach(image => formData.append('files', image.file, image.file.name));
    }
    this.loaderService.setLoading(true);
    this.userService.create(`${this.uploadUrl}`, formData)
      .subscribe({
        next: (response) => {
          if (response != null) {
            this.uploadDataResponse = response;
            console.log(this.uploadDataResponse);
            if (response.csvUploadProgress == 1 && response.imageUploadProgress == 1) {
              this.toastr.success('CSV and Images are uploaded successfully.');
              this.onCloseModal();
            }
            else if (response.csvUploadProgress == 1 && response.imageUploadProgress == 0) {
              this.toastr.success('CSV uploaded successfully.');
              this.onCloseModal();
            }
            else if (response.csvUploadProgress == 0 && response.imageUploadProgress == 1) {
              this.toastr.success('Images uploaded successfully.');
              this.onCloseModal();
            }
            else if (response.csvUploadProgress == 2 && (response.imageUploadProgress == 1 || response.imageUploadProgress == 0)) {
              this.isSuccess = false;
              this.toastr.error("CSV not uploaded successfully.");
            }
            else if (response.imageUploadProgress == 2 && (response.csvUploadProgress == 1 || response.csvUploadProgress == 0)) {
              this.isSuccess = false;
              this.toastr.error("Images not uploaded successfully.");
            }
            else if (response.csvUploadProgress == 2 && response.imageUploadProgress == 2) {
              this.isSuccess = false;
              this.toastr.error("CSV and Images not uploaded successfully.");
            }
            else {
              this.toastr.error('An error occurred during processing. Please check your file and try again.');
              this.onCloseModal();
            }
            this.loaderService.setLoading(false);
          }
        }
      });
  }

  onCloseModal(callAPI: boolean = true) {
    this.selectedFile = null;
    this.fileName = null;
    this.images = [];
    this.uploadDataResponse = null;
    this.reUpload();
    this.onClose.emit(callAPI);
  }

  reUpload() {
    this.isSuccess = true;
  }
}
